import React, { useRef, useState, useEffect } from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import styles from "./styles";
import { Button, Grid, Typography } from "@material-ui/core";
import dropImage from "../../images/DropImage.svg";
import { filter, range } from "lodash";
import GDPDroppable from "../GDPDroppable";
import DraggableAnswer from "../DraggableAnswer";
import "animate.css/animate.css";

const PlayQuiz = (props) => {
  const {
    classes,
    dragStarted,
    setDragStarted,
    onSubmit,
    currentQuestion,
    answers,
    answeredCorrectly,
    setAnsweredCorrectly,
    prevQuestion,
    prevAnswer
  } = props;

  const [inStoreValue, setInStoreValue] = useState(false);
  const [inUnitAccount, setInUnitAccount] = useState(false);
  const [inMediumExchange, setInMediumExchange] = useState(false);
  const [currentAnswer, setCurrentAnswer] = useState(null);
  // const [currentPosition, setCurrentPosition] = useState({ x: 0, y: 0 })
  const [answered, setAnswered] = useState(false);
  const [dragChildStarted, setDragChildStarted] = useState(false);
  const [showDropIconSection, setShowDropIconSection] = useState(false);

  const storeOfvalue = useRef(null);
  const unitOfAccount = useRef(null);
  const mediumOfExchange = useRef(null);

  useEffect(() => {
    setTimeout(() => setShowDropIconSection(true), 800);
  }, []);

  const onDragUpdate = (e) => {
    if (
      checkIfInAnyBox(
        e.pageX || e.changedTouches[0].pageX,
        e.pageY || e.changedTouches[0].pageY,
        storeOfvalue.current
      )
    ) {
      setInStoreValue(true);
    }else if (
      checkIfInAnyBox(
        e.pageX || e.changedTouches[0].pageX,
        e.pageY || e.changedTouches[0].pageY,
        unitOfAccount.current
      )
    ) {
      setInUnitAccount(true);
    } else if (
      checkIfInAnyBox(
        e.pageX || e.changedTouches[0].pageX,
        e.pageY || e.changedTouches[0].pageY,
        mediumOfExchange.current
      )
    ) {
      setInMediumExchange(true);
    } else {
      setInStoreValue(false);
      setInUnitAccount(false);
      setInMediumExchange(false);
    }
  };

  const checkIfInAnyBox = (x, y, element) => {
    let targetX = element.offsetLeft;
    let targetY = element.offsetTop;
    let targetHeight = element.offsetHeight;
    let targetWidth = element.offsetWidth;
    return (
      x >= targetX &&
      x <= targetX + targetWidth &&
      y >= targetY &&
      y < targetY + targetHeight
    );
  };

  const onDragStart = (e) => {
    setDragStarted(true);
  };

  const ifStoreOfValue = (answer) => answer?.answer === "Store of Value";
  const ifUnitOfAccount = (answer) => answer?.answer === "Unit of Account";
  const ifMediumOfExchange = (answer) => answer?.answer === "Medium of Exchange";

  const onDragEnd = (e, setDragState) => {
    setDragState();

    if (!inStoreValue && !inUnitAccount && !inMediumExchange ) return;

    if (inStoreValue) {
      setCurrentAnswer({
        answer: "Store of Value",
        imgSrc: currentQuestion.icon,
        title: currentQuestion.title,
        desc: currentQuestion.desc,
      });
    } else if (inUnitAccount) {
      setCurrentAnswer({
        answer: "Unit of Account",
        imgSrc: currentQuestion.icon,
        title: currentQuestion.title,
        desc: currentQuestion.desc,
      });
    }else if (inMediumExchange) {
      setCurrentAnswer({
        answer: "Medium of Exchange",
        imgSrc: currentQuestion.icon,
        title: currentQuestion.title,
        desc: currentQuestion.desc,
      });
    }

    setAnswered(true);
    setInStoreValue(false);
    setInUnitAccount(false);
    setInMediumExchange(false);
  };

  const getAnswers = (ans) => {
    return filter(answers, { answer: ans });
  }

  return (
    <Grid>
      <Grid container alignItems="center" justify="flex-start">
        <Grid>
          <Typography variant="h4" className={classes.includedTitle}>
            WHICH FUNCTION OF MONEY?
            <Typography variant="h6" className={classes.nestedText}>(Described in <b>bold text</b>)</Typography>
          </Typography>
        </Grid>
        <DraggableAnswer
          showDraggable={!answered}
          onDragStart={onDragStart}
          onDragEnd={(e) => onDragEnd(e, () => setDragStarted(false))}
          onDragUpdate={onDragUpdate}
          currentQuestion={currentQuestion}
          dragStarted={dragChildStarted}
        />
      </Grid>
      <Grid className={classes.dropImageContainer}>
        {showDropIconSection && !dragStarted && (
          <Grid container justify="center">
            {answered ? (
              <Button
                // style={{ animationDuration: "1.5s" }}
                className={`${classes.submitButton
                  } animate__animated animate__bounceIn`}
                onClick={() => {
                  setAnsweredCorrectly(currentAnswer.answer === currentQuestion.answer)
                  onSubmit(currentAnswer)
                }}
              >
                Confirm Answer
              </Button>
            ) : (
              <img
                src={dropImage}
                className={`${
                  classes.dropImageStyle
                } animate__animated animate__bounceIn`}
              />
            )}
          </Grid>
        )}
      </Grid>

      <Grid container justify="space-between">
        <GDPDroppable
          aref={storeOfvalue}
          title="Store of Value"
          inAnswer={inStoreValue}
          ifAnswer={ifStoreOfValue}
          currentAnswer={currentAnswer}
          getAnswers={getAnswers}
          onDragStart={onDragStart}
          onDragEnd={onDragEnd}
          onDragUpdate={onDragUpdate}
          setAnswered={setAnswered}
          dragStarted={dragChildStarted}
          setDragStarted={setDragChildStarted}
          showAnimation={prevAnswer?.answer === "no" && answeredCorrectly === false}
        />

        <GDPDroppable
          aref={unitOfAccount}
          title="Unit of Account"
          inAnswer={inUnitAccount}
          ifAnswer={ifUnitOfAccount}
          currentAnswer={currentAnswer}
          getAnswers={getAnswers}
          onDragStart={onDragStart}
          onDragEnd={onDragEnd}
          onDragUpdate={onDragUpdate}
          setAnswered={setAnswered}
          dragStarted={dragChildStarted}
          setDragStarted={setDragChildStarted}
          showAnimation={prevAnswer?.answer === "yes" && answeredCorrectly === false}
        />
        <GDPDroppable
          aref={mediumOfExchange}
          title="Medium of Exchange"
          inAnswer={inMediumExchange}
          ifAnswer={ifMediumOfExchange}
          currentAnswer={currentAnswer}
          getAnswers={getAnswers}
          onDragStart={onDragStart}
          onDragEnd={onDragEnd}
          onDragUpdate={onDragUpdate}
          setAnswered={setAnswered}
          dragStarted={dragChildStarted}
          setDragStarted={setDragChildStarted}
          showAnimation={prevAnswer?.answer === "yes" && answeredCorrectly === false}
        />
      </Grid>
    </Grid>
  );
};

export default withStyles(styles)(PlayQuiz);
